import {Component, Input, Output} from '@angular/core';
import {Subject} from 'rxjs';
import {NgbActiveModal, NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {CommonModule} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';
import {AlertComponent} from '../alert/alert.component';
import {AbstractSigaleComponent} from '../abstract-sigale.component';

@Component({
	standalone: true,
	selector: 'modal-confirmation',
	templateUrl: './confirmation.modal.html',
	styleUrls: ['./confirmation.modal.scss'],
	imports: [
		CommonModule,
		TranslateModule,
		NgbModule,
		AlertComponent
	]
})
export class ModalConfirmation extends AbstractSigaleComponent {
	@Input() titre: string;
	@Input() titreParams: any;
	@Input() message: string;
	@Input() messageParams: any;
	@Input() messageConfirmer: string;
	@Input() messageAnnuler: string;

	@Output('onValidate') onValidate: Subject<any> = new Subject<any>();

	constructor(public activeModal: NgbActiveModal) {
		super();
	}

	validate() {
		this.onValidate.next(true);
		// this.activeModal.close();
	}
}
